import { sectionConfig as config } from "~/config/_pages/about/saymyname";
import HeroUI from "~/components/ui/hero";

export default function SayMyName() {
  return (
    <div className="relative z-20 mx-auto my-20 mt-12 max-w-7xl gap-x-10 px-4">
      <HeroUI.Heading title={config.title} suptitle={config.suptitle} />
      <HeroUI.Paragraph>{config.caption}</HeroUI.Paragraph>
      <HeroUI.Paragraph>{config.caption2}</HeroUI.Paragraph>
      <p className="mt-4 mb-3 text-lg leading-tight font-bold text-gray-300 sm:text-xl">
        {config.final}
      </p>
    </div>
  );
}
